import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicNitricOxideDiagramContent } from "./CardiometabolicNitricOxideDiagram";
import { CardiometabolicNitricOxideKeyContent } from "./CardiometabolicNitricOxideKey";

const SvgCardiometabolicNitricOxideDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1424}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 869, 1147)}
      viewBox={diagramOnly ? "0 204 1424 869" : "0 0 1424 1147"}
    >
      <g id="cardiometabolic-nitricoxide-diagram+key" clipPath="url(#clip0_18293_231791)">
        <rect width={1424} height={diagramOnly ? 869 : 1147} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicNitricOxideKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicNitricOxideDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_231791">
          <rect width={1424} height={1147} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_231791">
          <rect width={1424} height={869} fill="white" transform="translate(0 204)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicNitricOxideDiagramKey;
